module.exports = __webpack_public_path__ + "img/no.b125cbd9.png";